import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { SWEEPS_TASK_BASE_PATH } from '../../../../../../../../../features/sweeps/clearing/task/sweeps-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-tasks-list',
        label: 'Sweeps',
        to: SWEEPS_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
